import { Typography } from "@mui/material"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { translate } from "app/language/service"
import { IForm } from "form/model"
import { getSummaryMediaCreativeInfos } from "form/tools/creative-forecast"
import { MediaType } from "media/components/MediaType"
import { IMediaCreativeForecastInfo } from "media/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { getDataGridTexts } from "ui/tools/list"

interface IForecastRequiredCreativeSummaryProps {
  form: IForm
  contentWidth: number
}

export const ForecastRequiredCreativeSummary = React.memo(
  ({ contentWidth, form }: IForecastRequiredCreativeSummaryProps) => {
    const rows = getSummaryMediaCreativeInfos(form)
    if (rows.length === 0) {
      return (
        <Typography id="summary-forecast-media-empty" color="textSecondary" fontSize=".85rem" sx={{ ml: "1rem" }}>
          {translate("forecast.type.media.empty")}
        </Typography>
      )
    }
    if (contentWidth < 720) {
      return (
        <Typography id="summary-forecast-media-count" color="textPrimary" fontSize=".85rem" sx={{ ml: "1rem" }}>
          {translate("label.creatives.count", rows.length)}
        </Typography>
      )
    }
    const columns: Array<GridColDef<IMediaCreativeForecastInfo>> = [
      {
        field: "type",
        headerName: translate("label.type"),
        flex: 2,
        renderCell: params => <MediaType type={params.row.mediaType} />
      },
      {
        field: "width",
        headerName: translate("label.width"),
        flex: 3
      },
      {
        field: "height",
        headerName: translate("label.height"),
        flex: 3
      }
    ]
    return (
      <FlexBox
        id="summary-forecast-media-list"
        vertical
        ai="start"
        jc="start"
        gap
        fullWidth
        sx={{
          "p": "1rem",
          "& > *": {
            width: "15rem"
          },
          "& .MuiDataGrid-root": {
            width: "100%",
            minHeight: "20rem"
          },
          "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden"
          },
          "& .MuiDataGrid-cell": {
            fontSize: ".8rem",
            fontWeight: 300
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer"
          },
          "& .MuiDataGrid-row.Mui-selected": {
            backgroundColor: "inherit"
          },
          "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus, & .MuiDataGrid-cell":
            {
              outline: "none !important"
            },
          "& .MuiCheckbox-root.Mui-disabled": {
            display: "none"
          }
        }}>
        <DataGrid
          rows={rows}
          getRowId={r => r.forecastId}
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          initialState={{
            sorting: { sortModel: [{ field: "width", sort: "desc" }] }
          }}
          rowHeight={40}
          autoPageSize
          localeText={getDataGridTexts()}
        />
      </FlexBox>
    )
  }
)
